import { all, fork } from "redux-saga/effects";

import chatSaga from "./messageSaga";

export default function* rootSaga(){
    yield all([fork(chatSaga)]);
}